export const TextInputType = {
    TEXT: "text",
    FILE:"file",
    EMAIL: "email",
    PASSWORD: "password",
    NUMBER: "number",
    CHECKBOX: "checkbox",
    DATEPICKER:"datepicker",
    DATETIME:"datetime-local",
    TEXTAREA:"textarea",
}

export const NumberValueType = {
    INT: "INT",
    DECIMAL: "DECIMAL",
}
